// TableHeaderCorner.jsx

import React from 'react';

// Hooks
import { DEFAULT_CORNER_WIDTH, DEFAULT_OPEN_ONLY_CORNER_WIDTH } from 'views/table/hooks/useTableSettings';

// CSS
import './TableHeaderCorner.css';

// Components
import Checkbox from 'components/checkbox/Checkbox';

/**
 * TableHeaderCorner
 * 
 * Renders the corner cell of the table header, which contains the select all checkbox.
 * 
 * @returns {ReactNode} - TableHeaderCorner.
 */
const TableHeaderCorner = ({ allSelected = false, onToggleAll, showCheckboxes = true }) => {

    // ----- RENDER ----- //

    return (
        <div
          className="table-view-header-cell-container table-view-header-corner"
          style={{
            width: showCheckboxes ? DEFAULT_CORNER_WIDTH : DEFAULT_OPEN_ONLY_CORNER_WIDTH,
          }}
        >
            {showCheckboxes ? (
                <Checkbox
                  value={allSelected}
                  size="20"
                  onChange={onToggleAll}
                />
            ) : null}
        </div>
    )
};

// Dev Tools
TableHeaderCorner.displayName = 'TableHeaderCorner';

export default TableHeaderCorner;
